export const shorten = (str: string, maxLen: number, separator = " "): string => {
	if (str.length <= maxLen) return str;
	return str.substr(0, str.lastIndexOf(separator, maxLen));
};
